export const filterModeActiveSelector = ({filterModeActive}) => filterModeActive